module.exports = __webpack_public_path__ + "img/floor_f8_02.28593d36.png";